
<div class="row" v-if="showAttachmentsView">
  <div class="col-12 attachments">
    <div class="d-flex justify-content-between align-items-center" v-if="header">
      <div v-if="filteredAttachments.length" class="label mt-2 mb-2">{{ header }}</div>
      <div class="downloadAllButton" @click="downloadAll" v-if="!disableDownloadAll">
        <i class="far fa-download"></i>
        Download all
      </div>
    </div>
    <div
      class="d-flex align-items-center attachment"
      v-for="attachment in filteredAttachments"
      :key="attachment.id"
      @click="downloadFile(attachment)"
      v-viewer="vvieweroptions"
    >
      <div class="attachment-thumbnail">
        <img
          class="img-fluid"
          style="max-height: 100%"
          :src="apiUrl + '/Attachment/thumbnail/' + attachment.id"
          :data-src="apiUrl + '/Attachment/attachment/' + attachment.id"
          v-if="imageFileExtensions.indexOf(attachment.fileExtension) !== -1"
        />
        <span v-else>{{ attachment.fileExtension.toUpperCase().replace('.', '') }}</span>
      </div>
      <div>
        <div>{{ attachment.fileName }}</div>
        <small>
          Added by {{ attachment.userFullName }} at
          {{ attachment.createdDate | formatDate }}
        </small>
        <div v-if="attachment.isChildItem">
          <small>
            Attachment from linked item -
            <router-link
              :to="{
                name: 'BoardItemDetail',
                params: { itemid: attachment.parentId },
              }"
            >
              {{ attachment.parentTitle }}
            </router-link>
          </small>
        </div>
      </div>
      <div class="delete-attachment" v-if="!readOnly">
        <div
          class="badgebutton active mr-2"
          v-b-tooltip:hover
          title="Display inline"
          v-on:click.stop="moveAttachmentToInline(attachment)"
          v-if="canBeDisplayedInline(attachment)"
        >
          <i class="far fa-arrow-alt-up"></i>
        </div>

        <div
          class="badgebutton active mr-2"
          v-b-tooltip:hover
          title="Comment on this attachment"
          v-on:click.stop="commentOn(attachment)"
          v-if="canComment"
        >
          <i class="far fa-comment-lines"></i>
        </div>
        <div
          class="badgebutton danger active"
          v-b-tooltip:hover
          title="Delete this attachment"
          v-on:click.stop="confirmDelete(attachment)"
          v-if="canDelete"
        >
          <i class="far fa-trash"></i>
        </div>
      </div>
    </div>
  </div>
</div>
